import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.list-unmatched-credit-card-items.views.UnmatchedCreditCardItemsPane`

export default defineMessages({
  paneTitle: {
    id: `${scope}.paneTitle`,
    defaultMessage: 'Procurify items',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search for Procurify items',
  },
  sortDateLabel: {
    id: `${scope}.sortDateLabel`,
    defaultMessage: 'Date',
  },
  sortTotalCostLabel: {
    id: `${scope}.sortTotalCostLabel`,
    defaultMessage: 'Total cost',
  },
  sortDescriptionLabel: {
    id: `${scope}.sortDescriptionLabel`,
    defaultMessage: 'Description',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'There are no unmatched items',
  },
  selectRowAriaLabel: {
    id: `${scope}.selectRowAriaLabel`,
    defaultMessage: 'Select {description}',
  },
  poTag: {
    id: `${scope}.poTag`,
    defaultMessage: 'PO',
  },
  rfeTag: {
    id: `${scope}.rfeTag`,
    defaultMessage: 'RFE',
  },
  suggestedMatchesChip: {
    id: `${scope}.suggestedMatchesChip`,
    defaultMessage:
      '{count} suggested {count, plural, one {match} other {matches}}',
  },
  packingSlipLabel: {
    id: `${scope}.packingSlipLabel`,
    defaultMessage: 'View',
  },
  invalidCurrencyLabel: {
    id: `${scope}.invalidCurrencyLabel`,
    defaultMessage: 'Invalid currency',
  },
  invalidCurrencyTooltip: {
    id: `${scope}.invalidCurrencyTooltip`,
    defaultMessage: "This item's currency does not match the card currency",
  },
})
